import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Drawer,
  Input,
  AutoComplete,
  Card,
  Button,
  Badge,
  Modal,
  Search,
  Icon,
  Spin,
  Tooltip,
  List,
  Space,
} from "antd";
import plusicon from "../images/plusIcon.svg";
import addIcon from "../images/GroupAdminAddicon.svg";
import { Form } from "@ant-design/compatible";
import ListTaxNpi from "./ListNpiTax";
import DeleteModal from "./DeleteModal";
import BlankNpi from "../images/BlankNpi.svg";
import InvalidTax from "../images/InvalidTax.svg";
import AddNpiGroup from "./AddNpiGroup";
import IPAsCards from "./IPAsCards";
import Config from "../../config";
import axios from "axios";
import "./AddUser.css";
import AdduserLogo from "../images/Adduserroute.svg";
import iconsMinus from "../images/iconsMinus.png";
import close from "../images/GroupAdmincloseIcon.svg";
import addAllPlus from "../images/Addallplusbutton.svg";

export default function AddIPAs2(props) {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isButtonUpdate, setIsButtonUpdate] = useState(false);
  const [AddButtonClicked, setAddButtonClicked] = useState(false);
  const [accessNpis, setAccessNpis] = useState([]);
  const [searchNpis, setSearchNpis] = useState(false);
  const [filteredNpis, setFilteredNpis] = useState([]);
  const [dataLoader, setDataLoader] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoading, setdataLoading] = useState(false);
  const [updateLoading, setupdateLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [type, setType] = useState("new");
  const [showDrawer, setShowDrawer] = useState(false);
  const [showAddIPAsButton, setShowAddIPAsButton] = useState(true);
  const [placement, setPlacement] = useState("bottom");
  const [NPIstate, setNPIstate] = useState("");
  const [totalTaxNPIs, setTotalTaxNPIs] = useState([]);
  const [ListOfNPIWithPlan, setListOfNPIWithPlan] = useState([]);
  const [SelectedNPIList, setSelectedNPIList] = useState([]);
  const [value, setValue] = useState("");
  const [combinations, setCombinations] = useState([]);
  const [combinations1, setCombinations1] = useState([]);
  const [selTaxId, setSelTaxId] = useState(null);
  const [selTaxNPIs, setSelTaxNPIs] = useState([]);
  const [dummy, setDummy] = useState("");
  const [npisList, setNpisList] = useState([]);
  const [showList, setShowList] = useState(false);
  const [selItemsComb, setSelItemsComb] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [savedNpiList, setSavedNpiList] = useState([]);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [displayAllIPA, setDisplayAllIPA] = useState([]);
  const [displaySelectedIPA, setDisplaySelectedIPA] = useState([]);

  useEffect(() => {
    const tempDisplayArr = data.map((ele) => {
      if(!selectedItems.some(item => item.ipa === ele.ipa)){
        return ele;
      }
      return null;
    }).filter(ele => ele !== null);
    setDisplayAllIPA(tempDisplayArr)
  },[selectedItems])

  useEffect(() => {
    const tempDisplayAllArr = data.map((ele) => {
      if(!selectedItems.some(item => item.ipa === ele.ipa)){
        return ele;
      }
      return null;
    }).filter(ele => ele !== null && ele.ipa !== null)
    setDisplayAllIPA(tempDisplayAllArr.filter(ele => ele.ipa.toLowerCase().includes(searchQuery.toLowerCase())))
    setDisplaySelectedIPA(selectedItems.filter(ele => ele.ipa.toLowerCase().includes(searchQuery.toLowerCase())))
  }, [searchQuery]);

  useEffect(
    () => {
      const planName = sessionStorage.getItem("planName");
      const ipaList = [sessionStorage.getItem("IPAList")] == "" ? [] : sessionStorage.getItem("IPAList").match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g).map(function(item) {
        return item.replace(/"/g, '');
      });
      setCombinations1(props.getCombinations1 ? props.getCombinations1 : []);
      setdataLoading(true)
      const fetchData = async () => {
        try {
        const response = await fetch(
          Config.Providerapi + "/GetListofIPA", {
            method: "POST",
            headers: {
              Authorization: sessionStorage.getItem("access_token"),
              Accept: "application/json",
              "Content-type": "application/json",
            },
            body: JSON.stringify({
              PlanName: planName,
              IPAList: ipaList,
              TaxidNPIFilter: {}
            }),
          });
          if (!response.ok) {
            setdataLoading(false)
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          
          const data = await response.json();
          console.log(data)
          setdataLoading(false)
          setData(data.IPADetails.filter(ele => ele !== null && ele.ipa !== null));
          setDisplayAllIPA(data.IPADetails.filter(ele => ele !== null && ele.ipa !== null));
          setCombinations1(props.getCombinations1 ? props.getCombinations1 : []);
        } catch (error) {
          console.error("Error fetching data:", error);
          setdataLoading(false)
        }
      };

      //  setSelectedItems(props.selectedItem)
      fetchData();
    },
    () => {
      setCombinations(props.getCombinations ? props.getCombinations : []);
      setSavedNpiList(props.savedNpiList ? props.savedNpiList : "");
    },
    () => {
      getParticularComb();
      getNpiListOnPlan();
    },
    () => {
      setCombinations1(props.getCombinations1 ? props.getCombinations1 : []);
      setSelectedItems(props.getCombinations1 ? props.getCombinations1 : []);
      setDisplaySelectedIPA(props.getCombinations1 ? props.getCombinations1 : []);
    });

  const handleAdd2 = () => {
    console.log("pls select");
  };
  const handleAdd = async () => {
    {
      // console.log("On Add",props.getCombinations1)
      // console.log("On Add2", selectedItems)
      setCombinations1(selectedItems);
      setupdateLoading(true)
      props.setUpdateClick(true)
      // console.log("IN AddIPAs");
      //    // console.log("ssl")
      try {
        // const token = 'your-token'; // Replace with your actual token
       
        const requestBody = {
          PlanName: sessionStorage.getItem("planName"),
          IPAList: selectedItems.map((obj) => obj.ipa),
        };
        const response = await fetch(
          Config.Providerapi + `/GetTaxIDandNPIDetailsByIPA?Planname=${sessionStorage.getItem("planName")}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: sessionStorage.getItem("access_token"),
            },
            body: JSON.stringify(requestBody),
          }
        );

        if (response.ok) {
          setTimeout(() => {
            setupdateLoading(false)
          }, 1000);
          
          const data = await response.json();
          // Handle the data returned from the API
          // console.log("data>>", data);
          props.setTaxIDandNPIDetailsByIPA(data);
        } else {
          // Handle the error response from the API
          // console.error("API request failed:", response.statusText);
        }
      } catch (error) {
        setupdateLoading(false)
        // Handle any network or general errors
        // console.error("API request failed:", error);
      }
      props.setCombinations1(selectedItems);
      //props.setEditClick(selectedItems);
      // console.log("proooo",props.setCombinations1)
      setShowDrawer(false);
      setShowAddIPAsButton(false);
      // // console.log("rr",response)
    }
  };
  // console.log("combinations>>",combinations1)

  const handleSelect = (item) => {
    const updatedItems = displayAllIPA.filter(
      (selectedItem) => selectedItem !== item
    );
    setSelectedItems([...selectedItems, item]);
    setDisplaySelectedIPA([...selectedItems, item]);
    setIsButtonEnabled(true);
  };

  const handleSelectAll = (item) => {
    setSelectedItems(item);
    setDisplaySelectedIPA(item);
    setIsButtonEnabled(true);
  };

  const handleDeselect = (item) => {
    const updatedItems = selectedItems.filter(
      (selectedItem) => selectedItem !== item
    );
    setSelectedItems(updatedItems);
    setDisplaySelectedIPA(updatedItems);
    setIsButtonEnabled(selectedItems.length - 1 == 0 ? false : true);
  };

  
  const getNpiListOnPlan = async () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
      },
    };
    let plan = sessionStorage.getItem("planName");

    let taxNpiMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping"));

    let requestedNpis = [];
    if (taxNpiMapping && taxNpiMapping.length > 0) {
      taxNpiMapping.map((item) => {
        if (item.NPI) {
          item.NPI.map((npi) => {
            if (!requestedNpis.includes(npi)) {
              requestedNpis.push(npi);
            }
          });
        }
      });
    }
    // setState({ accessNpis: requestedNpis })
    setAccessNpis(requestedNpis);
    let tmpArray = [];
    let npis = [];
    await axios
      .post(
        `${Config.api}/ListNPIBasedOnPlan?PlanName=${plan}`,
        { NpiNumber: requestedNpis },
        axiosConfig
      )
      .then((res) => {
        // setState({
        //   dataLoader: true
        // })
        setDataLoader(true);
        let npiList = res.data.Details;
        for (var i = 0; i < npiList.length; i++) {
          let name =
            !npiList[i].FacilityName
              ? `${npiList[i].FirstName}${
                  npiList[i].MiddleName ? " " + npiList[i].MiddleName : ""
                } ${npiList[i].LastName}`
              : npiList[i].FacilityName;
          tmpArray.push(name + "-" + npiList[i].NPINumber);
          if (
            savedNpiList.length > 0 &&
            savedNpiList.includes(npiList[i].NPINumber)
          ) {
            npis.push({
              npi: npiList[i].NPINumber,
              name: name,
              save: true,
              delete: false,
            });
          }
        }
      })
      .catch((er) => {
        // console.log("er", er);
      })
      .finally(() => {
        let npiCombination = combinations.filter(
          (item) => item.taxId === "None"
        )[0];
        if (npiCombination && savedNpiList.length > 0)
          npiCombination.npis = npis; // this line is creating problem
        setListOfNPIWithPlan(tmpArray);
        setCombinations(combinations);
        setDataLoader(true);
      });
  };

  const OpenDrawer = (value) => {
    setShowDrawer(!showDrawer);
    setNPIstate(value === "TaxId" ? "TaxId" : "Npi");
    setSelectedNPIList([]);
    setSelTaxNPIs([]);
    setTotalTaxNPIs([]);
    setNpisList([]);
    setSelTaxId(null);
    setType("new");
    setShowList(true);
  };

  const setNpisList2 = (npis) => {
    setTotalTaxNPIs(npis);
    // setState({
    //   totalTaxNPIs: npis
    // })
  };

  const onBlurEvent = () => {
    setSearchInput("");
    setSearchNpis(false);
    setFilteredNpis([]);
  };
  const onChange = (val) => {
    setSearchInput(val);
    setSearchNpis(false);

    if (!val || !val.trim()) {
      setFilteredNpis([]);
    }
  };

  const anyValidation = (rule, value, callback) => {
    const { form } = props;
    let combination = selItemsComb.filter((item) => item.taxId == value);
    if (combination.length > 0 && type === "new") {
      callback("This combination already exist!");
    } else callback();
  };

  const checkUserRole = (role) => {
    let userRoles = sessionStorage.getItem("rolename");
    return userRoles.includes(role);
  };

  const validateTaxId = (taxId) => {
    if (checkUserRole("Group User") || checkUserRole("IPA User")) {
      let taxIDMapping = JSON.parse(sessionStorage.getItem("taxidNpiMapping"));
      let selectedItem = taxIDMapping.filter((item) => item.TaxID == taxId)[0];
      if (!selectedItem) {
        return false;
      } else return true;
    } else return true;
  };

  const onSearch = async (e) => {
    // props.form.validateFields(async (err, values) => {
    //   if (!err) {
    const headers = {
      Authorization: sessionStorage.getItem("access_token"),
      Accept: "application/json",
      "Content-type": "application/json",
    };
    let npisList = [];
    setSelTaxId(e);
    // if PA then ok, but if ipa user/ group user then check tax id belongingness
    if (!validateTaxId(e)) return;
    // setState({
    //   isLoading: true,
    //   npisList: []
    // })
    setIsLoading(true);
    setNpisList([]);

    const promise = await fetch(
      `${Config.api}/ListNPIBasedOnTaxID?PlanName=${sessionStorage.getItem(
        "planName"
      )}`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({
          TaxId: [e],
          GroupTaxId: [e],
        }),
      }
    );

    let res = await promise.json();
    let npis = [];
    let _selTaxNpis = [];
    let roles = sessionStorage.getItem("rolename");
    let filteredNpis =
      roles.includes("Group User") || roles.includes("IPA User")
        ? res.Details.filter(
            (item) =>
              accessNpis.includes(item.GroupNPI) ||
              accessNpis.includes(`${item.ProviderNPI}`)
          )
        : res.Details;
    filteredNpis.map((item) => {
      let name = `${item.FirstName ? item.FirstName : ""}${
        item.MiddleName ? " " + item.MiddleName : ""
      } ${item.LastName ? item.LastName : ""}`;
      if (selTaxNPIs.findIndex((val) => val.npi == item.ProviderNPI) < 0) {
        // new case
        npis.push({
          id: item.PrimaryTaxId,
          npi: item.ProviderNPI,
          GroupNPI: item.GroupNPI,
          name,
          delete: false,
          save: false,
        });
      } else {
        if (type === "edit") {
          _selTaxNpis.push({
            id: item.PrimaryTaxId,
            npi: item.ProviderNPI,
            GroupNPI: item.GroupNPI,
            name,
            delete: false,
            save: true,
          }); //edit combination
        }
      }
      npisList.push({
        id: item.PrimaryTaxId,
        npi: item.ProviderNPI,
        GroupNPI: item.GroupNPI,
        name,
        delete: false,
        save: false,
      }); // not require delete & save
    });

    // let totalUniqueNPIs = []
    npis = npis.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.npi === value.npi)
    );

    npisList = npisList.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.npi === value.npi)
    );

    _selTaxNpis = _selTaxNpis.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.npi === value.npi)
    );
    setTotalTaxNPIs(npis);
    setShowDrawer(true);
    setSelTaxId(e);
    setSelTaxNPIs(type === "edit" ? _selTaxNpis : selTaxNPIs);
    setIsLoading(false);
    setNpisList(npisList);

    //   await setState({
    //     totalTaxNPIs: npis,
    //     showDrawer: true,
    //     selTaxId: e,
    //     selTaxNPIs:
    //       type === "edit" ? _selTaxNpis : selTaxNPIs,
    //     isLoading: false,
    //     npisList: npisList,
    //   });
    // }
    // })
  };
  const handleSearchQueryChange = (e) => {
    setSelectedItems({
      ...selectedItems,
      searchQuery: e.target.value,
    });
  };
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const removeTaxNPI = (item, type) => {
    let removedItem = selTaxNPIs.filter((val) => val.npi === item.npi)[0];

    if (removedItem.save) removedItem.delete = true;
    let index = selTaxNPIs.findIndex((val) => val.npi === item.npi);

    const newList = selTaxNPIs.filter((val) => {
      return val.npi !== item.npi;
    });
    // setState({
    //   selTaxNPIs: removedItem.save ? selTaxNPIs : [...newList],
    //   totalTaxNPIs: [...totalTaxNPIs, item],
    // });
    setSelTaxNPIs(removedItem.save ? selTaxNPIs : [...newList]);
    setTotalTaxNPIs([...totalTaxNPIs, item]);
  };

  const addTaxNPI = (item, type) => {
    if (type === "All") {
      let allItems = [...npisList]; //npisList has save false
      for (let item of selTaxNPIs) {
        let index = allItems.findIndex((i) => i.npi == item.npi);
        allItems[index].save = true; // to maintain save status
      }
      //   setState({
      //     selTaxNPIs: allItems,
      //     totalTaxNPIs: [] //as all npis are added
      //   });
      setSelTaxNPIs(allItems);
      setTotalTaxNPIs([]);
    } else {
      //item is individual obj of npi
      // item.save = false // to add this
      item.delete = false; // to add thisZZZ

      let itemExist = selTaxNPIs.filter((val) => val.npi == item.npi)[0];
      if (itemExist) {
        // itemExist.save = false
        itemExist.delete = false;
      }
      const newList = totalTaxNPIs.filter((val) => {
        return val.npi !== item.npi;
      });
      //   setState({
      //     totalTaxNPIs: newList,
      //     selTaxNPIs: itemExist ? [...selTaxNPIs] : [...selTaxNPIs, item]
      //   });
      setTotalTaxNPIs(newList);
      setSelTaxNPIs(itemExist ? [...selTaxNPIs] : [...selTaxNPIs, item]);
    }
  };

  const closeDrawer = () => {
    setShowDrawer(false);
    setDisplayAllIPA(data);
    setSelectedItems([]);
    setDisplaySelectedIPA([]);
  };

  const AddButton = () => {
    setAddButtonClicked(true);
    showDrawer(false);
  };

  const getParticularComb = () => {
    // to remove those combinations & npis which are deleted
    let selectedComb = [];
    combinations.forEach((item) => {
      let _npis = [];
      if (!item.delete) {
        for (let npi of item.npis) {
          if (!npi.delete) _npis.push(npi);
        }
        if (_npis.length > 0)
          selectedComb.push({ taxId: item.taxId, npis: _npis });
      }
    });
    // setState({
    //   selItemsComb: selectedComb
    // })
    setSelItemsComb(selectedComb);
  };

  const showAddNPIs = () => {
    let selVal = combinations.filter(
      (item) => item.taxId === "None" && !item.delete
    );
    if (selVal && selVal.length > 0) return false;
    else return true;
  };

  const onSelect = (item) => {
    let itemExist = SelectedNPIList.filter(
      (val) => val.npi == item.split("-")[1]
    )[0];
    if (itemExist) {
      //only for already save values
      itemExist.delete = false;
    } else {
      // newly added
      SelectedNPIList.push({
        delete: false,
        save: false,
        name: item.split("-")[0],
        npi: item.split("-")[1],
      });
    }
    setSelectedNPIList(SelectedNPIList);
    setFilteredNpis([]);
    setSearchNpis(false);
  };

  const DeleteNPI = (item) => {
    if (item.save) {
      item.delete = true;
      //   setState({
      //     SelectedNPIList: SelectedNPIList,
      //   });
      setSelectedNPIList(SelectedNPIList);
    } else {
      let newNpis = SelectedNPIList.filter((val) => val.npi != item.npi);
      //   setState({
      //     SelectedNPIList: [...newNpis],
      //   });
      setSelectedNPIList([[...newNpis]]);
    }
  };

  const submitHandler = () => {
    if (type === "edit") updateCombination();
    else addCombination();
    props.form.resetFields();
  };
  const updateCombination = () => {
    if (NPIstate === "Npi") {
      let index = combinations.findIndex((item) => item.taxId === "None");
      combinations[index].npis = SelectedNPIList;
    } else {
      //TaxId
      let index = combinations.findIndex((item) => item.taxId === selTaxId); // have to update this
      combinations[index].npis = selTaxNPIs;
    }
    // setState({
    //   combinations: combinations,
    //   showDrawer: false
    // })
    setCombinations(combinations);
    setShowDrawer(false);
    props.setCombinations(combinations);
    getParticularComb();
  };
  const addCombination = () => {
    if (NPIstate === "TaxId") {
      combinations.push({
        taxId: selTaxId,
        npis: selTaxNPIs,
        delete: 0,
        save: 0,
      });
    } else {
      combinations.push({
        taxId: "None",
        npis: SelectedNPIList,
        delete: false,
        save: false,
      });
    }
    closeDrawer();
    props.setCombinations(combinations);
  };

  const showModal = () => {
    // setState({
    //   deleteModal: !deleteModal
    // })
    setDeleteModal(!deleteModal);
  };

  const editCombination = async (combinations1) => {
    setIsButtonUpdate(true);
    setIsButtonEnabled(false);
    setSelectedItems(combinations1);
    setDisplaySelectedIPA(combinations1);
    props.setEditClick(true)
    setShowDrawer(true);
    // setNPIstate(item.taxId === "None" ? "Npi" : "TaxId");
  };

  

  const { Search } = Input;
  // const { getFieldDecorator } = props.form;

  return (
    <div className="pt-2">
      <div className="px-2">
        <Row justify="space-between" type="flex">
          <Col className="question-css"></Col>
          <Col className="gutter-row">
            {showAddIPAsButton && combinations1 == 0 && (
              <button
                className="butto-alluser ml-3"
                onClick={() => OpenDrawer("Npi")}
              >
                Add IPAs
              </button>
            )}
          </Col>
        </Row>
      </div>
      {/* Drawer Starts from here */}

      <Drawer
        style={{ borderRadius: "28px 28px 0px 0px" }}
        title="Select IPAs"
        className="custom-drawer"
        placement={placement}
        closable={false}
        // onClose={props.onClose}
        open={showDrawer}
        key={placement}
        height="90%"
      >
        <div className="px-4 mb-2 pb-3">
          {NPIstate === "TaxId" ? (
            <Col style={{ marginTop: "20px" }}>
              <Form></Form>
            </Col>
          ) : (
            <Col style={{ marginTop: "20px" }} className="mb-2">
              <Search
                style={{ height: "41px" }}
                placeholder={"Search IPAs"}
                enterButton="Search"
                size="large"
                // onSearch={handleSearch}
                // value={searchQuery}
                onChange={handleSearch}
              />

              {searchNpis &&
                filteredNpis.length === 0 &&
                searchInput.trim() && (
                  <div style={{ color: "red" }}>No record found!</div>
                )}

              {searchInput.trim() === "" && searchNpis && (
                <div style={{ color: "red" }}>
                  Enter a valid NPI or Name to search!
                </div>
              )}
            </Col>
          )}
        </div>
        {/* Calling list Tax Npi component */}

        {NPIstate != "TaxId" && (
          //    <div className="pl-4 pt-2 pr-4 pb-3">
          //   {/* {dataLoader && <Row
          //     style={{
          //       textAlign: "center",
          //       marginTop: "30vh"
          //     }}>
          //     <Spin size="large" />
          //    </Row>} */}
          //    <IPAsCards selectedItems={selectedItems}/>
          // </div>
          <></>
        )}
        <div className="pl-4 pt-2 pr-4 pb-1">
          {/* {dataLoader && <Row
              style={{
                textAlign: "center",
                marginTop: "30vh"
              }}>
              <Spin size="large" />
             </Row>} */}
             <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Card
                title={
                  <div>
                    <span style={{ fontWeight: "bold", fontSize: "medium" }}>
                      All IPAs
                    </span>
                    <button
                      className="butto-alluser pl-2 pr-2"
                      onClick={() => handleSelectAll(data)}
                      style={{ float: "right" }}
                    >
                      Add All IPAs
                      <span className="ml-3">
                        <img style={{paddingBottom: "3px"}} src={addAllPlus}></img>
                      </span>
                    </button>
                  </div>
                }
                style={{ width: "50%", height: "310px", overflow: "auto" }}
              >
                <List
                  dataSource={displayAllIPA}
                  loading={{
                    spinning: dataLoading,
                    tip: "Loading data...",
                    indicator: <Spin size="large" />, // bigger loader
                  }}
                  style={{
                    minHeight: "200px",            // ensures space for loader
                    background: "#fff",            // optional
                    borderRadius: "8px",           // optional rounded look
                    padding: "16px",               // space inside
                  }}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        <Space>
                          <span style={{ float: "left", cursor: "pointer" }}>
                            <img src={addIcon} onClick={() => handleSelect(item)}></img>
                          </span>
                          <span style={{ color: "black" }}>{item.ipa}</span>
                        </Space>,
                      ]}
                    ></List.Item>
                  )}
                />
              </Card>
                {/* <FirstCard
                  data={data}
                  selectedItems={selectedItems}
                  handleSelect={handleSelect}
                  handleSelectAll={handleSelectAll}
                /> */}
                <Card
                  title={
                    <div>
                      <span style={{ fontWeight: "bold", fontSize: "medium" }}>
                        Selected IPAs{" "}
                      </span>
                      <span style={{ fontWeight: "normal", fontSize: "smaller" }}>
                        (Total Selected: {selectedItems.length ? selectedItems.length : 0})
                      </span>
                    </div>
                  }
                  style={{ width: "49%", height: "310px", overflow: "auto"  }}
                >
                  {displaySelectedIPA.length > 0 && (
                    <List
                      dataSource={displaySelectedIPA}
                      renderItem={(item) => (
                        <List.Item
                          actions={[
                            <Space>
                              <span style={{ float: "left", cursor: "pointer" }}>
                                <img
                                  src={close}
                                  onClick={() => handleDeselect(item)}
                                ></img>
                              </span>
                              <span style={{ color: "black" }}>{item.ipa}</span>
                            </Space>,
                          ]}
                        ></List.Item>
                      )}
                    />
                  )}
                  {displaySelectedIPA.length == 0 && (
                    <Col className="sub-text-npi" style={{ marginTop: "20vh" }}>
                      “Added IPAs will Appear here”
                    </Col>
                  )}
                </Card>
              </div>
              {/* <button className="ml-3 butto-alluser pl-4 pr-4" onClick={handleAdd}>Add</button> */}
              <div className="m-4 pb-3" justify="space-between" type="flex">
                <Col></Col>
                <Col>
                  <Col span={12} pull={4}>
                    <button
                      onClick={handleAdd}
                      className="ml-3 butto-alluser pl-4 pr-4"
                    >
                      {"Add"}
                    </button>
                  </Col>
                  {/* )} */}
                </Col>
              </div>
            </div>
            
          {/* <IPAsCardsNew
            selectedItems={selectedItems}
            AddButtonClicked={AddButtonClicked}
          /> */}
        </div>

        {/* Done and cancle Button for TaxId and NPI */}

        <Row className="ml-4 mr-4 mt-1 mb-1 pb-3" justify="space-between" type="flex">
          <Col>
            {/* {type === "edit" &&
                <button
                  className="delete-alluser danger pl-4 pr-4"
                  onClick={showModal}
                >
                  Delete Combination
                </button>
              } */}
          </Col>
          <Col>
          {(updateLoading == true &&
          <Spin style={{marginRight:"20px"}} size="large" />
          )}
            <button className="cancle-button pl-4 pr-4" onClick={closeDrawer}>
              Cancel
            </button>{" "}
            <span>
              <button
                className={
                  !isButtonEnabled || selectedItems.length == 0
                    ? "ml-3 butto-alluser disabled pl-4 pr-4"
                    : "ml-3 butto-alluser pl-4 pr-4"
                }
                onClick={handleAdd}
                disabled={!isButtonEnabled || selectedItems.length == 0}
              >
                Update
              </button>
            </span>
          </Col>
        </Row>
      </Drawer>

      <div>
        {/* added data loader for handling add npi comb, need to wait to filter names from npilist*/}
        {dataLoader && selItemsComb.length > 0 && (
          <Row
            style={{
              textAlign: "center",
              marginTop: "3vh",
            }}
          >
            <Spin size="large" />
          </Row>
        )}
        {combinations1.length > 0 && (
          <Card className="card-css py-2 mb-2 mt-4 px-3 mx-2">
            <Row>
              <Col span={23} className="question-css">
                {/* <b>0{index + 1}. Tax ID: {item.taxId}</b> */}
                <b>{combinations1.length} IPAs Selected</b>
              </Col>
              <Col span={1} className="question-css">
                <Button
                  size="small"
                  type="link"
                  onClick={() => editCombination(combinations1)}
                >
                  Edit
                </Button>
              </Col>
            </Row>
          </Card>
        )}
      </div>
    </div>
  );
}
